import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'DistanceConverter'
})
export class DistanceConverter implements PipeTransform {
    transform(distance: number, unit: string): number {
        // server always return kms, so no need to convert when preference is KM
        if (unit === 'K') {
            return distance;
        }
        return distance / 1.6093;
    }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/pipes/distance-converter.pipe.ts